import React, { Component } from 'react';
import { Glyphicon, FormGroup, FormControl, ControlLabel, Panel, Button } from "react-bootstrap";
import UserProfile from './UserProfile';
import Input from './UI/Input/Input';
import "./EuronetCredits.css";
import AlertElement from './UI/Alert/Alert';
import axios from 'axios';
import Utility from './Utility';

export class EuronetCredits extends Component {
    displayName = EuronetCredits.name

    constructor(props) {
        super(props);
        this.state = {
            forecasts: [],
            loading: false,
            showerror: false,
            errorheader: '',
            errortext: '',
            formsconfig:
            {
                show: false,
                type: 0,
            },
            objform: {
                dateFrom: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'date',
                        placeholder: 'Da Data Accredito:'
                    },
                    value: Utility.todayDate(),
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                },
                dateTo: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'date',
                        placeholder: 'A Data Accredito:'
                    },
                    value: Utility.todayDate(),
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                },
                //id: {
                //    elementType: 'hidden',
                //    elementConfig: {
                //        type: 'text',
                //        placeholder: 'Id'
                //    },
                //    value: '0',
                //    validation: {
                //        required: true
                //    },
                //    valid: false,
                //    touched: true
                //},
                //dataAccredito: {
                //    elementType: 'input',
                //    elementConfig: {
                //        type: 'date',
                //        placeholder: 'Data Accredito'
                //    },
                //    value: '',
                //    validation: {
                //        required: true
                //    },
                //    valid: false,
                //    touched: false
                //},
            },
            formIsValid: false,
        };
        //this.refresh();
    }
    todayDate() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1;
        var yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        return yyyy + '-' + mm + '-' + dd;
    }
    formatDate(date) {
        var day = date.getDate();
        var monthIndex = date.getMonth();
        var year = date.getFullYear();

        return year + '-' + monthIndex+1 + '-' + day;
    }

    refresh() {
        let data = JSON.stringify({
            Token: UserProfile.getLogin().token,
            DateFrom: this.state.objform.dateFrom.value,
            DateTo: this.state.objform.dateTo.value
        })
        axios.post('api/EuronetCredits/List', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                this.setState({ forecasts: respose.data, loading: false });
            })
            .catch(data => {
            });
    }
    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    }
    clickdismiss() {
        this.state.showerror = false;
        this.forceRender();
    }
    forceRender = event => {
        this.setState({ time: Date.now() })
    }
    inputChangedHandler = (event, inputIdentifier) => {
        const updatedForm = {
            ...this.state.objform
        };
        const updatedFormElement = {
            ...updatedForm[inputIdentifier]
        };
        updatedFormElement.value = event.target.value;
        updatedFormElement.valid = true;
        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;
        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }
        if (inputIdentifier == 'dateFrom' || inputIdentifier == 'dateTo') {
            this.setState({ objform: updatedForm, formIsValid: formIsValid }, () => {
                //this.refresh();
            });
        } else {
            this.setState({ objform: updatedForm, formIsValid: formIsValid });
            //this.forceRender();
        }
    }

    ricerca = (event) => {
        this.refresh();
        this.forceRender();
    }

    static renderTable(forecasts) {
        return (
            <table className='table' >
                <thead>
                    <tr>
                        <th>Data Accredito</th>
                        <th>Matricola</th>
                        <th>Importo </th>
                        <th>Id Euronet</th>
                    </tr>
                </thead>
                <tbody>
                    {forecasts.map(forecast =>
                        <tr key={forecast.idAccredito}>
                            <td>{forecast.data}</td>
                            <td>{forecast.matricola}</td>
                            <td>{(Math.round(forecast.importo * 100) / 100).toFixed(2)} EUR</td>
                            <td>{forecast.idRicariche}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
    render() {
        const formElementsArray = [];
        for (let key in this.state.objform) {
            formElementsArray.push({
                id: key,
                config: this.state.objform[key]
            });
        }
        let formInser = (
            <div className="row">
                {formElementsArray.map(formElement => (
                    <div className="col-sm-3" key={'div' + formElement.id}>
                        <Input
                            key={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={formElement.config.value}
                            invalid={!formElement.config.valid}
                            shouldValidate={formElement.config.validation}
                            touched={formElement.config.touched}
                            changed={(event) => this.inputChangedHandler(event, formElement.id)}
                            textdisabled={false} />
                    </div>
                ))}
                <div className="col-sm-10">
                    <button onClick={(event) => this.ricerca(event)} type="button" className="btn btn-info">RICERCA</button>
                </div>
            </div>
        );
        let contents = this.state.loading
            ? <p className="col-sm-10"><em>Loading...</em></p>
            : EuronetCredits.renderTable(this.state.forecasts);

        return (
            <div>
                {(this.state.showerror == true) && <AlertElement strong={this.state.errorheader} message={this.state.errortext} clicked={(event) => this.clickdismiss(event)} />}
                <h1>Accrediti Euronet</h1>
                <span></span>
                {formInser}
                {contents}
            </div>
        );
    }
}
